module.exports = __webpack_public_path__ + "img/Mason.51664fa8.jpg";